{
  "verified": "2026-09-13",
  "url": "https://ec.europa.eu/eurostat/api/dissemination/statistics/1.0/data/isoc_cicce_use?lang=en&time=2025&indic_is=E_CC&unit=PC_ENT",
  "sha256": "268292b2a03c1e866186141f676ec8bc0f7f3a11b51773b58f21b7cc119c0f0e",
  "updated": "2026-02-27T11:00:00+0100",
  "industryUrl": "https://ec.europa.eu/eurostat/api/dissemination/statistics/1.0/data/isoc_cicce_usen2?lang=en&time=2025&indic_is=E_CC&unit=PC_ENT&geo=EU27_2020&size_emp=GE10",
  "industrySha256": "64f4912984ab86edd668c5ec3a6b36181f23ef37e8dd867480eb09ac9879c36b",
  "countries": [
    {
      "code": "EU27_2020",
      "label": "European Union - 27 countries (from 2020)",
      "values": [
        {
          "index": 328,
          "value": 52.74,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 246,
          "value": 49.3,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 369,
          "value": 66.78,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 410,
          "value": 84.67,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EU27_2020",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "BE",
      "label": "Belgium",
      "values": [
        {
          "index": 333,
          "value": 61.62,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 251,
          "value": 57.11,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 374,
          "value": 77.65,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 415,
          "value": 93.47,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "BG",
      "label": "Bulgaria",
      "values": [
        {
          "index": 334,
          "value": 17.83,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 252,
          "value": 14.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 375,
          "value": 30.13,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 416,
          "value": 49.12,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "BG",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "CZ",
      "label": "Czechia",
      "values": [
        {
          "index": 335,
          "value": 54.9,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 253,
          "value": 50.55,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 376,
          "value": 67.92,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 417,
          "value": 85.89,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CZ",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "DK",
      "label": "Denmark",
      "values": [
        {
          "index": 336,
          "value": 68.88,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 254,
          "value": 65.42,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 377,
          "value": 81.36,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 418,
          "value": 92.36,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DK",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "DE",
      "label": "Germany",
      "values": [
        {
          "index": 337,
          "value": 53.91,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 255,
          "value": 50.68,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 378,
          "value": 65.19,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 419,
          "value": 85.58,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "DE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "EE",
      "label": "Estonia",
      "values": [
        {
          "index": 338,
          "value": 60.66,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 256,
          "value": 55.71,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 379,
          "value": 82.24,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 420,
          "value": 92.9,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "IE",
      "label": "Ireland",
      "values": [
        {
          "index": 339,
          "value": 73.04,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 257,
          "value": 70.73,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 380,
          "value": 81.89,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 421,
          "value": 94.15,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "EL",
      "label": "Greece",
      "values": [
        {
          "index": 340,
          "value": 24.33,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 258,
          "value": 21.16,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 381,
          "value": 37.56,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 422,
          "value": 72.47,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "EL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "ES",
      "label": "Spain",
      "values": [
        {
          "index": 341,
          "value": 41.65,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 259,
          "value": 36.96,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 382,
          "value": 60.02,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 423,
          "value": 80.9,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "ES",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "FR",
      "label": "France",
      "values": [
        {
          "index": 342,
          "value": 40.41,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 260,
          "value": 35.78,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 383,
          "value": 62.67,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 424,
          "value": 84.65,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FR",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "HR",
      "label": "Croatia",
      "values": [
        {
          "index": 343,
          "value": 46.61,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 261,
          "value": 42.33,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 384,
          "value": 65.83,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 425,
          "value": 84.59,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HR",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "IT",
      "label": "Italy",
      "values": [
        {
          "index": 344,
          "value": 75.6,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 262,
          "value": 74.13,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 385,
          "value": 84.88,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 426,
          "value": 90.89,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "IT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "CY",
      "label": "Cyprus",
      "values": [
        {
          "index": 345,
          "value": 51.38,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 263,
          "value": 48.06,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 386,
          "value": 68.23,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 427,
          "value": 82.83,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "CY",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LV",
      "label": "Latvia",
      "values": [
        {
          "index": 346,
          "value": 44.08,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 264,
          "value": 40.12,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 387,
          "value": 59.16,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 428,
          "value": 83.41,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LV",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LT",
      "label": "Lithuania",
      "values": [
        {
          "index": 347,
          "value": 58.06,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 265,
          "value": 52.68,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 388,
          "value": 76.45,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 429,
          "value": 91.01,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "LU",
      "label": "Luxembourg",
      "values": [
        {
          "index": 348,
          "value": 47.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 266,
          "value": 44.7,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 389,
          "value": 57.33,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 430,
          "value": 70.99,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "LU",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "HU",
      "label": "Hungary",
      "values": [
        {
          "index": 349,
          "value": 47.96,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 267,
          "value": 43.96,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 390,
          "value": 66.19,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 431,
          "value": 87.95,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "HU",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "MT",
      "label": "Malta",
      "values": [
        {
          "index": 350,
          "value": 75.07,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 268,
          "value": 71.61,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 391,
          "value": 87.18,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 432,
          "value": 91.73,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "MT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "NL",
      "label": "Netherlands",
      "values": [
        {
          "index": 351,
          "value": 68.49,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 269,
          "value": 64.49,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 392,
          "value": 82.46,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 433,
          "value": 90.83,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "NL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "AT",
      "label": "Austria",
      "values": [
        {
          "index": 352,
          "value": 52.08,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 270,
          "value": 48.11,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 393,
          "value": 68.36,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 434,
          "value": 88.75,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "AT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "PL",
      "label": "Poland",
      "values": [
        {
          "index": 353,
          "value": 54.71,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 271,
          "value": 50.23,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 394,
          "value": 72.99,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 435,
          "value": 89.79,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PL",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "PT",
      "label": "Portugal",
      "values": [
        {
          "index": 354,
          "value": 38.71,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 272,
          "value": 34.53,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 395,
          "value": null,
          "flag": "u",
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": "low reliability"
        },
        {
          "index": 436,
          "value": 80.1,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "PT",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "RO",
      "label": "Romania",
      "values": [
        {
          "index": 355,
          "value": 24.94,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 273,
          "value": 23.08,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 396,
          "value": 30.15,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 437,
          "value": 48.17,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "RO",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SI",
      "label": "Slovenia",
      "values": [
        {
          "index": 356,
          "value": 48.04,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 274,
          "value": 43.37,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 397,
          "value": 65.75,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 438,
          "value": 90.18,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SI",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SK",
      "label": "Slovakia",
      "values": [
        {
          "index": 357,
          "value": 36.44,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 275,
          "value": 31.5,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 398,
          "value": 52.36,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 439,
          "value": 66.25,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SK",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "FI",
      "label": "Finland",
      "values": [
        {
          "index": 358,
          "value": 79.21,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 276,
          "value": 76,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 399,
          "value": 91.81,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 440,
          "value": 97.98,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "FI",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    },
    {
      "code": "SE",
      "label": "Sweden",
      "values": [
        {
          "index": 359,
          "value": 72,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE10",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 277,
          "value": 68.23,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "10-49",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 400,
          "value": 87.22,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "50-249",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        },
        {
          "index": 441,
          "value": 94.35,
          "flag": null,
          "coordinates": {
            "freq": "A",
            "size_emp": "GE250",
            "nace_r2": "C10-S951_X_K",
            "indic_is": "E_CC",
            "unit": "PC_ENT",
            "geo": "SE",
            "time": "2025"
          },
          "flagDescription": null
        }
      ]
    }
  ],
  "industries": [
    {
      "code": "C",
      "label": "Manufacturing",
      "index": 2,
      "value": 53.96,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "C",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "D_E",
      "label": "Electricity, gas, steam and air conditioning supply; water supply; sewerage, waste management and remediation activities",
      "index": 21,
      "value": 62.11,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "D_E",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "F",
      "label": "Construction",
      "index": 25,
      "value": 47.47,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "F",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "G",
      "label": "Wholesale and retail trade; repair of motor vehicles and motorcycles",
      "index": 26,
      "value": 51.34,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "G",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "H",
      "label": "Transportation and storage",
      "index": 31,
      "value": 46.57,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "H",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "I",
      "label": "Accommodation and food service activities",
      "index": 32,
      "value": 39.52,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "I",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "J",
      "label": "Information and communication",
      "index": 34,
      "value": 82.92,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "J",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "L",
      "label": "Real estate activities",
      "index": 39,
      "value": 61.61,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "L",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "M",
      "label": "Professional, scientific and technical activities",
      "index": 41,
      "value": 67.4,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "M",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "N",
      "label": "Administrative and support service activities",
      "index": 47,
      "value": 51.96,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "N",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    },
    {
      "code": "S951",
      "label": "Repair of computers and communication equipment",
      "index": 49,
      "value": 69.72,
      "flag": null,
      "coordinates": {
        "freq": "A",
        "size_emp": "GE10",
        "nace_r2": "S951",
        "indic_is": "E_CC",
        "unit": "PC_ENT",
        "geo": "EU27_2020",
        "time": "2025"
      },
      "flagDescription": null
    }
  ]
}
